import styles from './styles/main.module.css';

import TaskTracker from './projects/TaskTracker';
import Osusu from './projects/Osusu';
import ProductC from './projects/ProductC';

const JaasWorks = () => {
    return (
        <main className={styles.jaasWorks}>
            <TaskTracker />
            <Osusu />
            <ProductC />
        </main>
    );
}
 
export default JaasWorks;